<template>
    <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
    >
      <v-row>
        <v-col>
          <p class="mb-2"><strong >Подсказка:</strong></p>
          <ol>
            <li class="mb-2">Зайдите в личный кабинет организации в ГИС ЖКХ</li>
            <li class="mb-2">Перейдите во вкладку Администрирование->Сотрудники
              <v-img
                class="mt-1"
                lazy-src="@/assets/img/debtors/instruction_2.jpg"
                max-height="150"
                max-width="250"
                src="@/assets/img/debtors/instruction_2.jpg"
                @click="openPic(require('@/assets/img/debtors/instruction_2.jpg'))"
              ></v-img>
            </li>
            <li class="mb-2">Из списка сотрудников скопируйте ФИО и ID отправителя (см. скриншот ниже)
              <v-img
                class="mt-1"
                lazy-src="@/assets/img/debtors/instruction_1.jpg"
                max-height="150"
                max-width="250"
                src="@/assets/img/debtors/instruction_1.jpg"
                @click="openPic(require('@/assets/img/debtors/instruction_1.jpg'))"
              ></v-img>
            </li>
          </ol>
          <span>Эти данные <strong>обязательны</strong> для отправки в <strong>ГИС ЖКХ</strong>.</span>
          <v-dialog v-model="dialog" max-width="60%" @keydown.esc="cancel">
            <v-card>
              <v-img :src="pic" alt="" contain/>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-alert>
</template>

<script>
export default {
  name: 'DebtorsConnectGIS',
  props:{
  },
  data() {
    return {
      dialog:false,
      pic: ""
    }
  },
  methods: {
    openPic(image) {
      this.dialog = true
      this.pic = image
    },
    cancel() {
      this.dialog = false
    }
  },
  created() {
  },
}
</script>